(function () {
  function init(root) {
    if (!root || root.dataset.ygpReady === "1") return;
    root.dataset.ygpReady = "1";

    const main = root.querySelector("[data-ygp-main]");
    root.querySelectorAll("[data-ygp-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (!main || !thumb.dataset.src) return;
        main.src = thumb.dataset.src;
        main.srcset = "";
        root.querySelectorAll("[data-ygp-thumb]").forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });

    const qty = root.querySelector("[data-ygp-qty]");
    root.querySelectorAll("[data-qty]").forEach((button) => {
      button.addEventListener("click", () => {
        if (!qty) return;
        const next = Math.max(1, Number(qty.value || 1) + Number(button.dataset.qty));
        qty.value = String(next);
      });
    });

    const dataEl = root.querySelector("[data-ygp-variants]");
    const idInput = root.querySelector("[data-ygp-id]");
    const priceEl = root.querySelector("[data-ygp-price]");
    const compareEl = root.querySelector("[data-ygp-compare]");
    const addBtn = root.querySelector("[data-add]");
    const buyBtn = root.querySelector("[data-buy-now]");
    const sticky = root.querySelector("[data-ygp-sticky]");
    const stickyPrice = root.querySelector("[data-ygp-sticky-price]");
    const stickyImg = root.querySelector("[data-ygp-sticky-img]");
    const stickyAdd = root.querySelector("[data-ygp-sticky-add]");
    const stickyBuy = root.querySelector("[data-ygp-sticky-buy]");
    const form = root.querySelector("form[action*='/cart/add']");
    let variants = [];

    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent || "[]");
      } catch (error) {
        variants = [];
      }
    }

    function setImage(src) {
      if (!src) return;
      if (main) {
        main.src = src;
        main.srcset = "";
      }
      if (stickyImg) stickyImg.src = src;
      root.querySelectorAll("[data-ygp-thumb]").forEach((thumb) => {
        thumb.classList.toggle("is-active", thumb.dataset.src === src);
      });
    }

    function setAvailability(available) {
      [addBtn, buyBtn, stickyAdd, stickyBuy].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
      });
      const label = available ? "Add to Cart" : "Sold out";
      if (addBtn) addBtn.textContent = label;
      if (stickyAdd) stickyAdd.textContent = label;
    }

    function currentOptions() {
      return Array.from(root.querySelectorAll("[data-option-index]")).map((group) => {
        return group.querySelector(".is-active")?.dataset.value || "";
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compareEl) {
        if (variant.compare) {
          compareEl.hidden = false;
          compareEl.textContent = variant.compare;
        } else {
          compareEl.hidden = true;
          compareEl.textContent = "";
        }
      }
      setAvailability(Boolean(variant.available));
      setImage(variant.image);
    }

    root.querySelectorAll("[data-option-value]").forEach((button) => {
      button.addEventListener("click", () => {
        const group = button.closest("[data-option-index]");
        if (!group) return;
        group.querySelectorAll("[data-option-value]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        const options = currentOptions();
        const match = variants.find((variant) =>
          (variant.options || []).every((option, index) => option === options[index])
        );
        applyVariant(match);
      });
    });

    if (stickyAdd && addBtn) {
      stickyAdd.addEventListener("click", () => {
        if (!addBtn.disabled) addBtn.click();
      });
    }

    const buyRow = root.querySelector(".ygp-form");
    if (sticky && buyRow) {
      const syncSticky = () => {
        sticky.hidden = buyRow.getBoundingClientRect().bottom > 0;
      };
      if (root._ygpStickyScroll) {
        window.removeEventListener("scroll", root._ygpStickyScroll);
        window.removeEventListener("resize", root._ygpStickyScroll);
        root._ygpInfoScroll?.removeEventListener("scroll", root._ygpStickyScroll);
      }
      root._ygpStickyScroll = syncSticky;
      window.addEventListener("scroll", syncSticky, { passive: true });
      window.addEventListener("resize", syncSticky);
      syncSticky();
    }

    if (form && buyBtn) {
      buyBtn.addEventListener("click", async () => {
        if (buyBtn.disabled) return;
        buyBtn.disabled = true;
        const rootPath = window.Shopify?.routes?.root || "/";
        try {
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: "POST",
            body: new FormData(form),
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });
          if (response.ok) {
            window.location.href = `${rootPath}checkout`;
            return;
          }
          const payload = await response.json().catch(() => ({}));
          form.dispatchEvent(
            new CustomEvent("cart:error", {
              bubbles: true,
              detail: { error: payload.description || "Could not add this product." },
            })
          );
        } catch (error) {
          form.dispatchEvent(
            new CustomEvent("cart:error", {
              bubbles: true,
              detail: { error: "Could not add this product." },
            })
          );
        }
        const current = variants.find((variant) => String(variant.id) === String(idInput?.value));
        const available = current ? current.available : true;
        buyBtn.disabled = !available;
        if (stickyBuy) stickyBuy.disabled = !available;
      });
    }

    if (stickyBuy && buyBtn) {
      stickyBuy.addEventListener("click", () => {
        if (!buyBtn.disabled) buyBtn.click();
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-ygp]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-ygp]").forEach((node) => {
      delete node.dataset.ygpReady;
      init(node);
    });
  });
})();
